import EbdaEduNavbar from "components/navbars/EbdaEduNavbar";
import { useEffect, useState } from "react";
import { fetchAuthorities } from "services/data";

const EbdaEduNewOrg = () => {
    const [authorities, setAuthorities] = useState([]);
    const [name, setName] = useState("");
    const [location, setLocation] = useState("");
    const [type, setType] = useState("");
    const [selectedAuthority, setSelectedAuthority] = useState("");

    useEffect(() => {
        const loadAuthorities = async () => {
            const response = await fetchAuthorities();
            setAuthorities(response);
        }

        loadAuthorities();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            name,
            location,
            type,
            auth_id: Number(selectedAuthority)
        };

        // 🔹 Call your API here
        // await createOrganization(payload);
    };

    return (
        <div>
            <EbdaEduNavbar />

            <div className="flex justify-center mt-10">
                <form
                    onSubmit={handleSubmit}
                    className="w-[500px] bg-white shadow-lg rounded-2xl p-6 space-y-4"
                    dir="rtl"
                >
                    <h2 className="text-2xl font-bold text-center mb-4">
                        إضافة جهة جديدة
                    </h2>

                    {/* Name */}
                    <div className="flex flex-col">
                        <label className="font-semibold mb-1">الاسم</label>
                        <input
                            type="text"
                            className="border rounded-lg px-3 py-2"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>

                    {/* Location */}
                    <div className="flex flex-col">
                        <label className="font-semibold mb-1">الموقع</label>
                        <input
                            type="text"
                            className="border rounded-lg px-3 py-2"
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                            required
                        />
                    </div>

                    {/* Type */}
                    <div className="flex flex-col">
                        <label className="font-semibold mb-1">النوع</label>
                        <select
                            className="border rounded-lg px-3 py-2"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            required
                        >
                            <option value="">اختر النوع</option>
                            <option value="school">مدرسة</option>
                            <option value="company">شركة</option>
                        </select>
                    </div>

                    {/* Authority */}
                    <div className="flex flex-col">
                        <label className="font-semibold mb-1">الجهة</label>
                        <select
                            className="border rounded-lg px-3 py-2"
                            value={selectedAuthority}
                            onChange={(e) => setSelectedAuthority(e.target.value)}
                            required
                        >
                            <option value="">اختر الجهة</option>
                            {authorities.map(auth => (
                                <option id={auth.id} value={auth.id}>{auth.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* Submit */}
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-2 rounded-lg font-bold hover:bg-blue-700 transition"
                    >
                        حفظ
                    </button>
                </form>
            </div>
        </div>
    );
};

export default EbdaEduNewOrg;